import React from 'react';
import { LevelOfService } from '../../../../slices/marketplace/timeline/models/enums/level-of-service.enum';
import { BrokerageType } from '../../../../slices/marketplace/pricing/models/brokerage-type.enum';
import { MarketplacePricing } from '../../../../slices/marketplace/pricing/models/marketplace-pricing.model';
import { ComingSoonCommercialTermsCalculator } from '../../../PracticeBrokerageServices/ComingSoonCommercialTermsTable/CommingSoonCommercialTermsCalculator';
import { ComingSoonCommercialTermsTable } from '../../../PracticeBrokerageServices/ComingSoonCommercialTermsTable/ComingSoonCommercialTermsTable';

interface MyEngagementCommercialTermsProps {
    levelOfService: LevelOfService;
    startFteDvm: number;
    startLtmRevenue: number;
    marketplacePricing: MarketplacePricing;
}

export const MyEngagementCommercialTerms = (props: MyEngagementCommercialTermsProps) => {
    if (props.levelOfService === LevelOfService.StrategicFinancialAdvisoryService) {
        return null;
    }

    const brokerageType =
        props.levelOfService === LevelOfService.FullServiceBrokerage
            ? BrokerageType.FullService
            : BrokerageType.Discount;

    const data = ComingSoonCommercialTermsCalculator.calculateCommercialTerms(
        props.startFteDvm,
        props.startLtmRevenue,
        brokerageType,
        props.marketplacePricing
    );

    return (
        <div className="commercial-terms-section">
            <h6>My Engagement Commercial Terms</h6>
            <ComingSoonCommercialTermsTable data={data} />
        </div>
    );
};
